module.exports = __webpack_public_path__ + "static/media/MünchenMit.f042136a.jpg";